module.exports = __webpack_public_path__ + "img/20_102.3020ced7.png";